import Notification from './Notification'
import Exam from './Exam'
const exportObj = {
    Notification,
    Exam
}

export default exportObj